import apiTaskSolutions from '@/api/task-solutions';

const taskState = {
    draft: {
        // [project.id]: '書きかけのタスク内容'
    },
    solutions: [],
    status: {
        isActive: false
    }
};

const task = {
    namespaced: true,
    state: taskState,
    getters: {
        solutionLabel(state) {
            return state.solutions.reduce(
                (acc, current) =>
                    Object.assign(acc, { [current.id]: current.displayName }),
                {}
            );
        },
        solutionSelect(state) {
            return state.solutions.map(item => {
                return {
                    value: item.id,
                    label: item.displayName
                };
            });
        }
    },
    mutations: {
        setDraft(state, payload) {
            Object.assign(state.draft, payload);
        },
        setSolutions(state, payload) {
            state.solutions = payload;
        },
        setStatus(state, payload) {
            Object.assign(state.status, payload);
        },
        reset(state) {
            state.draft = Object.assign({}, taskState.draft);
            state.solutions = [];
            state.status = Object.assign({}, taskState.status);
        },
        resetDraft(state, payload) {
            delete state.draft[payload];
        }
    },
    actions: {
        async getTaskSolutions({ commit, rootState }) {
            const items = await apiTaskSolutions
                .get(rootState.user.status.idToken)
                .then(response => response.data.items)
                .catch(error => []);
            commit('setSolutions', items);
        },
        setDraft({ commit }, response) {
            commit('setDraft', response);
        },
        setStatus({ commit }, response) {
            commit('setStatus', response);
        },
        reset({ commit }) {
            commit('reset');
        },
        resetDraft({ commit }, response) {
            commit('resetDraft', response);
        }
    }
};

export default task;
